var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "checkout-section" },
    [
      _c(
        "div",
        { staticClass: "checkout-section__skip" },
        [
          _c("NavButton", {
            attrs: { text: _vm.data.excursions.bookWithoutExcursionsText },
            on: { beforeNextStep: _vm.resetExcursions },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "checkout-section__header" }, [
        _c("h2", { staticClass: "checkout-section__title" }, [
          _vm._v(_vm._s(_vm.data.excursions.title)),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "checkout-section__description",
          domProps: { innerHTML: _vm._s(_vm.data.excursions.descriptionHtml) },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tour-excursions__wrapper" }, [
        _c(
          "div",
          { staticClass: "personalise-wrapper" },
          _vm._l(_vm.excursionData.excursions, function (excursion) {
            return _c(
              "Excursion",
              {
                key: excursion.id,
                attrs: {
                  excursion: excursion,
                  data: _vm.excursionData,
                  brand: _vm.data.brandNameFormatted,
                },
              },
              [
                _c(
                  "ul",
                  { staticClass: "personalise__checkbox" },
                  _vm._l(_vm.quote.passengers, function (passenger) {
                    return _c(
                      "li",
                      { key: passenger.id, staticClass: "default-checkbox" },
                      [
                        _c("label", [
                          _c("input", {
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: _vm.passengerHasExcursion(
                                passenger,
                                excursion
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.togglePassengerExcursion(
                                  passenger,
                                  excursion
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "checkbox__label" }, [
                            _vm._v(_vm._s(_vm.passengerFullName(passenger))),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            )
          }),
          1
        ),
      ]),
      _vm._v(" "),
      _c("PriceBreakdown"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "checkout-section__footer" },
        [
          _c("NavButton", {
            class: {
              "btn btn--outline-gray-color btn--outline-gray-color_sm js-modal resultCardMapTs":
                _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
            },
            attrs: { back: true, text: "Back" },
            on: { beforePrevStep: _vm.resetExcursions },
          }),
          _vm._v(" "),
          _c("NavButton", { on: { beforeNextStep: _vm.setExcursions } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }